import React, { useCallback, useContext } from "react";
import { FormattedMessage } from "react-intl";
import activeCountries from "../../activeCountries";
import CountryContext from "../../CountryContext";
import AuthenticationService from "../../services/AuthenticationService";

const MenuStoreSelector = ({slim=false}) => {
  const { country } = useContext(CountryContext);
  const userData = AuthenticationService.getUserData();

  const userActiveCountries = userData?.countries?.split?.(";") || [];

  const onChange = useCallback((e) => {
    window.location = `/${e.target.value}`;
  }, []);

  if (userActiveCountries.length <= 1) {
    return null;
  }

  return (
    <div className="flex w-full justify-between items-center mt-2">
      {!slim && (
        <div className="font-semibold text-black-500 text-xs">
          <FormattedMessage id="country" defaultMessage="Country" />
        </div>
      )}
      <select
        className={`bg-transparent border-0 p-0 text-xs ${slim ? "w-full" : "w-1/3 -mr-3"}`}
        value={country.code}
        onChange={onChange}
      >
        {activeCountries.filter(x => userActiveCountries.includes(x.code)).map((c) => (
          <option key={c.code} value={c.code}>
            {c.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MenuStoreSelector;
